var _path, _path2, _g, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPenIconBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.7508 21.9397H13.4978C13.0838 21.9397 12.7478 21.6037 12.7478 21.1897C12.7478 20.7757 13.0838 20.4397 13.4978 20.4397H20.7508C21.1648 20.4397 21.5008 20.7757 21.5008 21.1897C21.5008 21.6037 21.1648 21.9397 20.7508 21.9397Z",
    fill: "#482714"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_457_5036",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 3,
    width: 18,
    height: 19
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.00037 3.00015H19.181V21.9397H2.00037V3.00015Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_457_5036)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.1106 5.0168L3.69564 16.7918C3.52464 17.0058 3.46164 17.2818 3.52464 17.5468L4.20564 20.4318L7.24464 20.3938C7.53364 20.3908 7.80064 20.2618 7.97764 20.0418C11.1946 16.0168 17.3276 8.3428 17.5016 8.1178C17.6656 7.8518 17.7296 7.4758 17.6436 7.1138C17.5556 6.7428 17.3246 6.4278 16.9916 6.2268C16.9206 6.1778 15.2356 4.8698 15.1836 4.8288C14.5496 4.3208 13.6246 4.4088 13.1106 5.0168ZM3.61364 21.9398C3.26664 21.9398 2.96464 21.7018 2.88364 21.3628L2.06464 17.8918C1.89564 17.1728 2.06364 16.4308 2.52464 15.8548L11.9446 4.0728C11.9486 4.0688 11.9516 4.0638 11.9556 4.0598C12.9886 2.8248 14.8566 2.6428 16.1166 3.6538C16.1666 3.6928 17.8396 4.9928 17.8396 4.9928C18.4476 5.3548 18.9226 6.0018 19.1026 6.7678C19.2816 7.5258 19.1516 8.3078 18.7346 8.9688C18.7036 9.0178 18.6766 9.0598 9.14864 20.9798C8.68964 21.5518 8.00164 21.8848 7.26264 21.8938L3.62364 21.9398H3.61364Z",
    fill: "#482714"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.2234 11.6848C16.0634 11.6848 15.9034 11.6338 15.7664 11.5298L10.3144 7.34181C9.98642 7.08981 9.92442 6.61981 10.1764 6.28981C10.4294 5.96181 10.8994 5.90081 11.2284 6.15281L16.6814 10.3398C17.0094 10.5918 17.0714 11.0628 16.8184 11.3918C16.6714 11.5838 16.4484 11.6848 16.2234 11.6848Z",
    fill: "#482714"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPenIconBlack);
export default __webpack_public_path__ + "static/media/penIconBlack.6ad08b353c2b3f2ac00fffc032008694.svg";
export { ForwardRef as ReactComponent };